import React from 'react';
import { Link } from 'react-router-dom';
export function CTABannerSection() {
  return <section className="relative w-full overflow-hidden py-20 px-4 sm:px-6 lg:px-8" data-id="element-127">
      {/* Background photo */}
      <img src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=1600&q=80" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" data-id="element-128" />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/75" data-id="element-129" />

      {/* Content */}
      <div className="relative z-10 text-center max-w-3xl mx-auto" data-id="element-130">
        <p className="text-xs font-bold uppercase mb-4" style={{
        color: '#FECB00',
        letterSpacing: '0.25em'
      }} data-id="element-131">
          Ameritech Tires
        </p>
        <h2 className="font-black text-white text-3xl sm:text-5xl mb-4 leading-tight" data-id="element-132">
          Quality Service and Customer Satisfaction!
        </h2>
        <p className="text-base mb-10" style={{
        color: 'rgba(255,255,255,0.70)'
      }} data-id="element-133">
          Three convenient DMV locations. No appointment needed. Open 24/7.
        </p>
        <Link to="/contact" className="inline-block text-white font-black uppercase tracking-widest px-12 py-5 text-sm transition-colors duration-200" style={{
        background: '#CC0000',
        letterSpacing: '0.15em'
      }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-134">
          BOOK NOW
        </Link>
      </div>
    </section>;
}